class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);

/* CompanyBlue query rewriter -------------------------------------------------

   Shopify's storefront search ORs the words you type. Measured on this
   catalogue, "electric towel rail 600x1200" returned 979 of 1432 products,
   because nearly everything here is an electric towel rail — every extra word
   the customer typed made the results worse. Joining the words with AND makes
   each word narrow instead of widen: the same query returns 38.

   Sizes get their own treatment because the catalogue writes them three ways —
   "600x1200mm", "600 x 1200" and "600mm Wide 1200mm High". A typed size is
   expanded to all three, so the customer doesn't have to guess our house
   style. Measured: 3 matches before the expansion, 32 after.

   The typed words ride along in `qd` so the results page can show the question
   rather than the machine query. With JavaScript off nothing is rewritten and
   the plain query still searches, just more loosely.
*/
(function () {
  if (window.cbSearchQuery) return;

  // Words that carry no weight in a catalogue where almost every title
  // contains them. ANDing these would drop products for no reason.
  var SKIP = {
    a: 1, an: 1, the: 1, and: 1, or: 1, of: 1, for: 1, in: 1, on: 1,
    my: 1, me: 1, size: 1, sized: 1, mm: 1, cm: 1,
  };

  // Anything that looks like search syntax is left exactly as typed.
  var HAS_SYNTAX = /["():]|\b(AND|OR|NOT)\b|(^|\s)-\S/;

  function sizeGroup(token) {
    var match = /^(\d{2,4})(?:mm)?[x×*](\d{2,4})(?:mm)?$/i.exec(token);
    if (!match) return null;
    var width = match[1];
    var height = match[2];
    return (
      '(' + width + 'x' + height +
      ' OR "' + width + ' x ' + height + '"' +
      ' OR ("' + width + 'mm Wide" AND "' + height + 'mm High"))'
    );
  }

  window.cbSearchQuery = function (raw) {
    var typed = (raw || '').trim();
    if (!typed || HAS_SYNTAX.test(typed)) return typed;

    // "600 x 1200" and "600mm X 1200" are one size, not three words.
    var normalised = typed.replace(/(\d{2,4})\s*(?:mm)?\s*[x×*]\s*(\d{2,4})/gi, '$1x$2');

    var terms = [];
    normalised.split(/\s+/).forEach(function (word) {
      var clean = word.replace(/["'():]/g, '');
      if (!clean || SKIP[clean.toLowerCase()]) return;
      terms.push(sizeGroup(clean) || clean);
    });

    if (!terms.length) return typed;
    return terms.join(' AND ');
  };

  function typedQuery() {
    try {
      return new URLSearchParams(window.location.search).get('qd');
    } catch (error) {
      return null;
    }
  }

  // The URL carries the machine query; the page should still say what was
  // asked for. Runs during parsing, so nothing flickers.
  function showTypedQuery() {
    var qd = typedQuery();
    if (!qd) return;

    document.querySelectorAll('input[name="q"]').forEach(function (input) {
      input.value = qd;
    });
    document.querySelectorAll('[data-cb-search-term]').forEach(function (element) {
      element.textContent = qd;
    });
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.action || form.action.indexOf('/search') === -1) return;

      var input = form.querySelector('input[name="q"]');
      if (!input) return;

      var typed = input.value.trim();
      var rewritten = window.cbSearchQuery(typed);
      if (!typed || rewritten === typed) return;

      event.preventDefault();
      var params = new URLSearchParams(new FormData(form));
      params.set('q', rewritten);
      params.set('qd', typed);
      window.location.assign(form.action.split('?')[0] + '?' + params.toString());
    },
    true
  );

  showTypedQuery();
  document.addEventListener('DOMContentLoaded', showTypedQuery);
})();
